import { MB } from "./fileTypes"

export type FileCategory =
    | "image"
    | "gif"
    | "audio"
    | "video"
    | "pdf"
    | "word"
    | "spreadsheet"
    | "presentation"
    | "markdown"
    | "svg"
    | "archive"
    | "unknown"

export const EXTENSION_TO_CATEGORY: Record<string, FileCategory> = {
    jpg: "image",
    jpeg: "image",
    png: "image",
    webp: "image",
    avif: "image",
    heic: "image",
    tif: "image",
    tiff: "image",
    bmp: "image",
    ico: "image",
    raw: "image",
    exr: "image",
    hdr: "image",

    gif: "gif",

    mp3: "audio",
    wav: "audio",
    aac: "audio",
    m4a: "audio",
    ogg: "audio",
    opus: "audio",
    flac: "audio",
    alac: "audio",
    wma: "audio",
    amr: "audio",
    aiff: "audio",
    aif: "audio",
    mid: "audio",
    midi: "audio",

    mp4: "video",
    mov: "video",
    avi: "video",
    mkv: "video",
    flv: "video",
    wmv: "video",
    mpeg: "video",
    mpg: "video",
    webm: "video",
    m4v: "video",
    ts: "video",
    rm: "video",
    rmvb: "video",
    "3gp": "video",
    f4v: "video",
    vob: "video",
    ogv: "video",
    mxf: "video",
    m2ts: "video",

    pdf: "pdf",

    doc: "word",
    docx: "word",
    dot: "word",
    dotx: "word",
    docm: "word",
    dotm: "word",
    rtf: "word",
    odt: "word",

    xls: "spreadsheet",
    xlsx: "spreadsheet",
    xlt: "spreadsheet",
    xltx: "spreadsheet",
    xlsm: "spreadsheet",
    xltm: "spreadsheet",
    ods: "spreadsheet",
    csv: "spreadsheet",
    tsv: "spreadsheet",
    prn: "spreadsheet",
    dbf: "spreadsheet",

    ppt: "presentation",
    pptx: "presentation",
    pot: "presentation",
    potx: "presentation",
    pps: "presentation",
    ppsx: "presentation",
    pptm: "presentation",
    potm: "presentation",
    ppsm: "presentation",
    key: "presentation",
    odp: "presentation",

    md: "markdown",
    markdown: "markdown",
    mdown: "markdown",
    mkd: "markdown",
    mkdn: "markdown",
    mkdwn: "markdown",
    mdwn: "markdown",
    ink: "markdown",
    rst: "markdown",

    svg: "svg",
    svgz: "svg",

    zip: "archive",
    rar: "archive",
    "7z": "archive",
    tar: "archive",
    gz: "archive",
    apk: "archive",
    war: "archive",
    iso: "archive",
}

export const MIME_PREFIX_TO_CATEGORY: Record<string, FileCategory> = {
    "image/gif": "gif",
    "image/svg+xml": "svg",
    "image/": "image",
    "audio/": "audio",
    "video/": "video",
    "application/pdf": "pdf",
}

export const DEFAULT_MAX_FILES = 25

export const DEFAULT_MAX_FILE_SIZE = 100 * MB

export const FILE_SIZE_UNITS = ["Bytes", "KB", "MB", "GB"] as const

export const FILE_UPLOAD_VERSION = {
    FILESTACK: 1,
    BYTESCALE: 2,
}
